import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import store from "@/store";

const files = {
  download: false,
  print: false,
  export: false,
};

Vue.prototype.$relatorios_sinteticos = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      recebimentos: [],
      recebimentos_totais: [],
      loading_recebimentos: false,
      loading_button_export_pdf: false,
      loading_button_export_csv: false,
      resumo_recebimentos: {
        saldo_disponivel: 0,
        aguardando_liberacao: 0,
        total_comissao: 0,
      },
      loading_resumo_recebimentos: false,

      venda_por_canal: [],
      venda_por_canal_totais: [],
      loading_venda_por_canal: false,

      venda_por_dia: [],
      venda_por_dia_totais: [],
      laoding_venda_por_dia: false,

      venda_forma_pagamento: [],
      venda_forma_pagamento_totais: [],
      loading_venda_forma_pagamento: false,

      venda_por_produto: [],
      venda_por_produto_totais: [],
      loading_venda_por_produto: false,

      venda_tipo_produto: [],
      venda_tipo_produto_totais: [],
      loading_venda_tipo_produto: false,

      consumidor_final: [],
      consumidor_final_totais: [],
      loading_consumidor_final: false,

      venda_por_pdv: [],
      loading_venda_por_pdv: false,
      pdv_loading: false,
      equipamentos_loading: false,
      // cancelamentos_taxas: [],
      // cancelamentos_taxas_totais: [],
      // loading_cancelamentos_taxas: false,

      filtros: [],
      loading_button: false,
      loading_button_consumidor: false,
      loading_button_cancelamentos: false,
      loading_select: false,
      filter_recebimentos: {
        tipo_pessoa: "idloja",
        pessoa: null,
        intervalo_datas: null,
        range_dates: [],
        initDate: "",
        initDateView: "",
        endDate: "",
        endDateView: "",
        error: {
          loja: [],
          range_dates: [],
        },
        loading: {
          saldos: false,
          recebimentos_listagem: false,
          totais: false,
        },
      },
      filter_venda_por_canal: {
        loja: null,
        intervalo_datas: null,
        canal_vendas: "",
        range_dates: [],
        error: {
          loja: [],
          range_dates: [],
        },
      },
      filter_venda_por_dia: {
        loja: null,
        intervalo_datas: null,
        range_dates: [],
        error: {
          range_dates: [],
          loja: [],
        },
      },
      filter_venda_forma_pagamento: {
        loja: null,
        forma_de_pagamento: "",
        intervalo_datas: null,
        range_dates: [],
        error: {
          loja: [],
          range_dates: [],
        },
      },
      filter_venda_produto: {
        loja: null,
        produto: "",
        intervalo_datas: null,
        range_dates: [],
        error: {
          range_dates: [],
          loja: [],
        },
      },
      filter_venda_tipo_produto: {
        loja: null,
        tipo_produto: "",
        tipo_variacao: "",
        intervalo_datas: null,
        range_dates: [],
        error: {
          range_dates: [],
          loja: [],
        },
      },
      filter_cupom_desconto: {
        loja: null,
        produto: "",
        codigo: "",
        consumidor: "",
        intervalo_datas: null,
        range_dates: [],
        error: {
          range_dates: [],
          loja: [],
        },
      },
      filter_consumidor_final: {
        loja: null,
        intervalo_datas: null,
        range_dates: [],
        error: {
          range_dates: [],
          loja: [],
        },
      },
      filter_venda_por_pdv: {
        loja: null,
        intervalo_datas: null,
        range_dates: [],
        ponto_de_venda: "",
        equipamento: "",
        forma_pag: "",
        error: {
          range_dates: [],
          loja: [],
        },
      },
      pontos_de_venda: [],
      equipamentos: [],
      // filter_cancelamentos_taxas: {
      //   loja: "",
      //   intervalo_datas: null,
      //   range_dates: [],
      //   canal_vendas: "",
      //   error: {
      //     range_dates: [],
      //     loja: [],
      //   },
      // },
      cupons_descontos: [],
      loading_cupom_desconto: false,
      loading_button_cupom: false,
      tipo_pessoa: [
        // { text: "Agente", value: "idagente" },
        { text: "Loja", value: "idloja" },
        { text: "Ponto De Venda", value: "idponto_venda" },
      ],
      intervalo_data: [
        { text: "Dia", value: "date" },
        { text: "Semana", value: "week" },
        { text: "Mês", value: "month" },
        { text: "Personalizado", value: "custom" },
      ],
      canais_de_venda: [],
      formas_de_pagamento: [],
    };
  },
  methods: {
    getEnviroment() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return true;
      else return false;
    },
    // FUNÇOES DE GET RELATÓRIOS
    getSaldos(dados) {
      this.loading_button = true;
      this.filter_recebimentos.loading.saldos = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_RECEBIMENTOS + "/saldos", dados)
        .then(res => {
          this.resumo_recebimentos.aguardando_liberacao = res.comissao_aguard;
          this.resumo_recebimentos.total_comissao = res.total_comissao;
          this.resumo_recebimentos.saldo_disponivel = res.comissao_disp;
          this.loading_button = false;
          this.filter_recebimentos.loading.saldos = false;
        })
        .catch(error => {
          this.loading_button = false;
          this.filter_recebimentos.loading.saldos = false;
          throw new Error(error);
        });
    },
    getListagemRecebimentos(dados) {
      this.loading_button = true;
      this.filter_recebimentos.loading.recebimentos_listagem = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_RECEBIMENTOS + "/listagem", dados)
        .then(res => {
          this.recebimentos = res;
          this.loading_button = false;
          this.filter_recebimentos.loading.recebimentos_listagem = false;
        })
        .catch(error => {
          this.loading_button = false;
          this.filter_recebimentos.loading.recebimentos_listagem = false;
          throw new Error(error);
        });
    },
    getTotaisRecebimentos(dados) {
      this.loading_button = true;
      this.filter_recebimentos.loading.totais = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_RECEBIMENTOS + "/total", dados)
        .then(res => {
          this.recebimentos_totais = res.length === 0 ? [] : [res];
          this.loading_button = false;
          this.filter_recebimentos.loading.totais = false;
        })
        .catch(error => {
          this.loading_button = false;
          this.filter_recebimentos.loading.totais = false;
          throw new Error(error);
        });
    },
    getVendasPorCanal(dados) {
      this.loading_button = true;
      this.loading_venda_por_canal = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_VENDA_POR_CANAL, JSON.stringify(dados))
        .then(response => {
          if (response) {
            const arrayOfObj = Object.entries(response.INFO).map(e => e[1]);
            this.venda_por_canal = arrayOfObj;
            this.venda_por_canal_totais =
              response.TOTAIS.length === 0 ? [] : [response.TOTAIS];
            this.loading_button = false;
            this.loading_venda_por_canal = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    getVendasPorDia(dados) {
      this.loading_button = true;
      this.loading_venda_por_dia = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_VENDA_POR_DIA, JSON.stringify(dados))
        .then(response => {
          if (response) {
            const arrayOfObj = Object.entries(response.INFO).map(e => e[1]);
            this.venda_por_dia = arrayOfObj;
            this.venda_por_dia_totais =
              response.TOTAIS.length === 0 ? [] : [response.TOTAIS];
            this.loading_button = false;
            this.loading_venda_por_dia = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    getConsumidorFinal(dados) {
      this.loading_button_consumidor = true;
      this.loading_consumidor_final = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_NF_CONSUMIDOR_FINAL, JSON.stringify(dados))
        .then(response => {
          if (response) {
            const arrayOfObj = Object.entries(response.rows).map(e => e[1]);
            this.consumidor_final = arrayOfObj;
            this.consumidor_final_totais =
              response.totais.length === 0 ? [] : [response.totais];
            this.loading_button_consumidor = false;
            this.loading_consumidor_final = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    // getCancelamentosTaxas(dados) {
    //   this.loading_button_cancelamentos = true;
    //   this.loading_cancelamentos_taxas = true;
    //   this.$axios
    //     .post(this.ENDPOINTS.LISTAR_CANCELAMENTOS_TAXAS, JSON.stringify(dados))
    //     .then(response => {
    //       if (response) {
    //         const arrayOfObj = Object.entries(response.INFO).map(e => e[1]);
    //         this.cancelamentos_taxas = arrayOfObj;
    //         this.cancelamentos_taxas_totais =
    //           response.TOTAIS.length === 0 ? [] : [response.TOTAIS];
    //         this.loading_button_cancelamentos = false;
    //         this.loading_cancelamentos_taxas = false;
    //       }
    //     })
    //     .catch(error => {
    //       throw new Error(error);
    //     });
    // },
    getVendasPorFormaDePagamento(dados) {
      this.loading_button = true;
      this.loading_venda_forma_pagamento = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_VENDA_POR_FORMA_PGT, JSON.stringify(dados))
        .then(response => {
          if (response) {
            const arrayOfObj = Object.entries(response.INFO).map(e => e[1]);
            this.venda_forma_pagamento = arrayOfObj;
            this.venda_forma_pagamento_totais =
              response.TOTAIS.length === 0 ? [] : [response.TOTAIS];
            this.loading_button = false;
            this.loading_venda_forma_pagamento = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    getVendasPorPdv(dados) {
      this.loading_button = true;
      this.loading_venda_por_pdv = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_VENDA_POR_PDV, JSON.stringify(dados))
        .then(response => {
          if (response) {
            this.venda_por_pdv = response;
            this.loading_button = false;
            this.loading_venda_por_pdv = false;
          }
        })
        .catch(error => {
          this.loading_button = false;
          this.loading_venda_por_pdv = false;
          throw new Error(error);
        });
    },
    getVendasPorProduto(dados) {
      this.loading_button = true;
      this.loading_venda_por_produto = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_VENDA_POR_PRODUTO, JSON.stringify(dados))
        .then(response => {
          if (response) {
            const arrayOfObj = Object.entries(response.INFO).map(e => e[1]);
            this.venda_por_produto = arrayOfObj;
            this.venda_por_produto_totais =
              response.TOTAIS.length === 0 ? [] : [response.TOTAIS];
            this.loading_button = false;
            this.loading_venda_por_produto = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    getVendasPorTipoDeProduto(dados) {
      this.loading_button = true;
      this.loading_venda_tipo_produto = true;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_VENDA_POR_TIPO_PRODUTO,
          JSON.stringify(dados)
        )
        .then(response => {
          if (response) {
            const arrayOfObj = Object.entries(response.INFO).map(e => e[1]);
            this.venda_tipo_produto = arrayOfObj;
            this.venda_tipo_produto_totais =
              response.TOTAIS.length === 0 ? [] : [response.TOTAIS];
            this.loading_button = false;
            this.loading_venda_tipo_produto = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    // FUNÇÕES AUXILIARES
    getCanaisDeVenda() {
      this.loading_select = true;
      this.$axios
        .get(this.ENDPOINTS.CANAIS_DE_VENDA + "/array")
        .then(response => {
          if (response) {
            this.$axios.setLocal("canais_venda", response);
            this.canais_de_venda = response;
            this.loading_select = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    getFormasDePagamento() {
      this.loading_select = true;
      this.$axios
        .get(this.ENDPOINTS.FORMAS_DE_PAGAMENTO + "array")
        .then(response => {
          this.$axios.setLocal("form_pagamentos", response);
          const modifiedResponse = response.map(item => {
            if (item.key === "QRCODE" && item.value === "QRCODE") {
              return { key: "PIX", value: "QRCODE" };
            }
            return item;
          });
          this.formas_de_pagamento = modifiedResponse;
          this.loading_select = false;
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    getPointOfSale(loja) {
      this.pdv_loading = true;
      let filtros = [];
      filtros.push({
        campo: "loja",
        tipo: "string",
        valor: loja,
      });
      this.$axios
        .post(this.ENDPOINTS.GET_POINTS_OF_SALE, JSON.stringify({ filtros }))
        .then(response => {
          this.pontos_de_venda = response;
          this.pdv_loading = false;
        });
    },
    getEquipments(ponto_de_venda) {
      this.equipamentos_loading = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_EQUIPAMENTO_DISPONIVEL + ponto_de_venda)
        .then(response => {
          this.equipamentos_loading = false;
          this.equipamentos = response;
        });
    },
    clearfilterDiaFields(field) {
      switch (field) {
        case "loja":
          this.filter_venda_por_dia.loja = "";
          break;
        case "dates":
          this.filter_venda_por_dia.range_dates = [];
      }
    },
    clearFilterFields(field) {
      switch (field) {
        case "tipo_produto":
          this.filter_venda_tipo_produto.tipo_produto = "";
          this.filter_venda_tipo_produto.loja = "";
          break;
        case "tipo_variacao":
          this.filter_venda_tipo_produto.tipo_variacao = "";
          break;
        case "venda_por_dia":
          this.filter_venda_por_dia.range_dates = [];
          this.filter_venda_por_dia.loja = "";
          break;
        case "consumidor_final":
          this.filter_consumidor_final.range_dates = [];
          break;
        case "tipo_produto_dates":
          this.filter_venda_tipo_produto.range_dates = [];
          break;
        case "forma_pagamento":
          this.filter_venda_forma_pagamento.forma_de_pagamento = "";
          this.filter_venda_forma_pagamento.loja = "";
          break;
        case "forma_pagamento_dates":
          this.filter_venda_forma_pagamento.range_dates = [];
          break;
        case "vendas_pdv_dates":
          this.filter_venda_por_pdv.range_dates = [];
          break;
        case "canal_venda":
          this.filter_venda_por_canal.canal_vendas = "";
          this.filter_venda_por_canal.loja = "";
          break;
        case "canal_venda_dates":
          this.filter_venda_por_canal.range_dates = [];
          break;
        case "produto_loja":
          this.filter_venda_produto.loja = "";
          break;
        case "produto":
          this.filter_venda_produto.produto = "";
          break;
        case "produto_dates":
          this.filter_venda_produto.range_dates = [];
          break;
        case "recebimento_tipo_pessoa":
          this.filter_recebimentos.tipo_pessoa = "";
          break;
        case "recebimento_pessoa":
          this.filter_recebimentos.pessoa = "";
          break;
        case "recebimento_pessoa_dates":
          this.filter_recebimentos.range_dates = [];
          break;
        case "cupom_desconto":
          this.filter_cupom_desconto.consumidor = "";
          break;
        case "cupom_desconto_dates":
          this.filter_cupom_desconto.range_dates = [];
          break;
        // case "cancelamentos_taxas":
        //   this.filter_cancelamentos_taxas.canal_vendas = "";
        //   this.filter_cancelamentos_taxas.loja = "";
        //   break;
        default:
          break;
      }
    },

    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index[0] == "data_venda") {
          if (!isDesc[0]) {
            return new Date(b[index]) - new Date(a[index]);
          } else {
            return new Date(a[index]) - new Date(b[index]);
          }
        } else if (index[0] == "valor") {
          if (!isDesc[0]) {
            return b[index] - a[index];
          } else {
            return a[index] - b[index];
          }
        } else if (index[0] == "valor_pedido") {
          if (!isDesc[0]) {
            return b[index] - a[index];
          } else {
            return a[index] - b[index];
          }
        } else if (index[0] == "comissao") {
          if (!isDesc[0]) {
            return b[index] - a[index];
          } else {
            return a[index] - b[index];
          }
        } else if (index[0] == "valor_desconto") {
          if (!isDesc[0]) {
            return b[index] - a[index];
          } else {
            return a[index] - b[index];
          }
        } else if (index[0] == "valor_total") {
          if (!isDesc[0]) {
            return b[index] - a[index];
          } else {
            return a[index] - b[index];
          }
        } else {
          if (typeof a[index] == "number") {
            if (!isDesc[0]) {
              return b[index] - a[index];
            } else {
              return a[index] - b[index];
            }
          } else if (typeof a[index] !== "undefined") {
            if (!isDesc[0]) {
              return a[index]
                .toLowerCase()
                .localeCompare(b[index].toLowerCase());
            } else {
              return b[index]
                .toLowerCase()
                .localeCompare(a[index].toLowerCase());
            }
          }
        }
      });
      return items;
    },

    // FILTRO
    filtro(relatorio) {
      this.filtros = [];
      let dados_forma = {};
      let dados_produto = {};
      let dados_tipo = {};
      let dados_canal = {};
      let dados_dia = {};
      let dados_consumidor = {};
      let dados = {
        idponto_venda: "",
        idagente: "",
        loja: "",
        tipo_pessoa: "",
      };

      let dados_venda_pdv = {};
      let dados_cupom = {};
      switch (relatorio) {
        case "recebimentos":
          if (this.filter_recebimentos.initDateView) {
            dados.dthr_ini = `${this.filter_recebimentos.initDate} 00:00`;
          }
          if (this.filter_recebimentos.endDateView) {
            dados.dthr_fim = `${this.filter_recebimentos.endDate} 00:00`;
          }

          switch (this.filter_recebimentos.tipo_pessoa) {
            case "idponto_venda":
              dados.tipo_pessoa = "PONTO_VENDA";
              dados.idponto_venda = this.filter_recebimentos.pessoa;
              break;
            case "idagente":
              dados.tipo_pessoa = "AGENTE";
              dados.idagente = this.filter_recebimentos.pessoa;
              break;
            case "idloja":
              dados.tipo_pessoa = "LOJA";
              dados.loja = store.getters.storeSequencial;
              break;
            default:
              dados.tipo_pessoa = "LOJA";
              dados.loja = store.getters.storeSequencial;
          }

          if (
            !this.filter_recebimentos.range_dates.length == 0 &&
            this.filter_recebimentos.range_dates.length < 2
          ) {
            this.loading_recebimentos = false;
            this.$config.alert(
              "Preencha adequadamente os campos!",
              this.$config.dados.errorColor
            );
            this.filter_recebimentos.error.range_dates =
              "Preencha adequadamente os campos!";
            return;
          }
          this.getSaldos(dados);
          this.getListagemRecebimentos(dados);
          this.getTotaisRecebimentos(dados);
          break;
        case "venda_por_canal":
          if (this.filter_venda_por_canal.range_dates.length > 0) {
            dados_canal.dthr_ped_ini =
              this.filter_venda_por_canal.range_dates[0] + " 00:00";
            dados_canal.dthr_ped_fim =
              this.filter_venda_por_canal.range_dates[1] + " 23:59";
          }

          if (
            this.filter_venda_por_canal.canal_vendas !== "" &&
            this.filter_venda_por_canal.canal_vendas !== null
          ) {
            dados_canal.canal_venda = this.filter_venda_por_canal.canal_vendas;
          }

          if (
            this.filter_venda_por_canal.loja !== "" &&
            this.filter_venda_por_canal.loja !== null
          ) {
            dados_canal.loja = this.filter_venda_por_canal.loja;
          }

          if (
            this.filter_venda_por_canal.loja != 0 ||
            this.filter_venda_por_canal.loja == null
          ) {
            if (
              (this.filter_venda_por_canal.loja == "" &&
                this.getEnviroment()) ||
              (this.getEnviroment() && this.filter_venda_por_canal.loja == null)
            ) {
              this.loading_venda_tipo_produto = false;
              this.$config.alert(
                "Selecione uma loja!",
                this.$config.dados.errorColor
              );
              this.filter_venda_por_canal.error.loja = "Selecione uma loja!";
              return;
            }
          }

          if (
            !this.filter_venda_por_canal.range_dates.length == 0 &&
            this.filter_venda_por_canal.range_dates.length < 2
          ) {
            this.loading_venda_por_canal = false;
            this.$config.alert(
              "Preencha adequadamente os campos!",
              this.$config.dados.errorColor
            );
            this.filter_venda_por_canal.error.range_dates =
              "Preencha adequadamente os campos!";
            return;
          }
          this.getVendasPorCanal(dados_canal);
          break;
        case "venda_por_dia":
          if (this.filter_venda_por_dia.range_dates.length > 0) {
            dados_dia.dthr_ped_ini =
              this.filter_venda_por_dia.range_dates[0] + " 00:00";
            dados_dia.dthr_ped_fim =
              this.filter_venda_por_dia.range_dates[1] + " 23:59";
          }
          if (
            this.filter_venda_por_dia.loja != 0 ||
            this.filter_venda_por_dia.loja == null
          ) {
            if (
              (this.getEnviroment() && this.filter_venda_por_dia.loja == "") ||
              (this.getEnviroment() && this.filter_venda_por_dia.loja == null)
            ) {
              this.loading_button = false;
              this.loading_venda_tipo_produto = false;
              this.$config.alert(
                "Selecione uma loja!",
                this.$config.dados.errorColor
              );
              this.filter_venda_por_dia.error.loja = "Selecione uma loja!";
              return;
            }
          }
          if (
            this.filter_venda_por_dia.loja !== "" &&
            this.filter_venda_por_dia.loja !== null
          ) {
            dados_dia.loja = this.filter_venda_por_dia.loja;
          }
          if (
            !this.filter_venda_por_dia.range_dates.length == 0 &&
            this.filter_venda_por_dia.range_dates.length < 2
          ) {
            this.loading_venda_por_dia = false;
            this.$config.alert(
              "Preencha adequadamente os campos!",
              this.$config.dados.errorColor
            );
            this.filter_venda_por_dia.error.range_dates =
              "Preencha adequadamente os campos!";
            return;
          }
          this.getVendasPorDia(dados_dia);
          break;
        case "venda_forma_pagamento":
          if (
            this.filter_venda_forma_pagamento.forma_de_pagamento !== "" &&
            this.filter_venda_forma_pagamento.forma_de_pagamento !== null
          ) {
            dados_forma.forma_pagamento =
              this.filter_venda_forma_pagamento.forma_de_pagamento;
          }

          if (
            this.filter_venda_forma_pagamento.loja !== "" &&
            this.filter_venda_forma_pagamento.loja !== null
          ) {
            dados_forma.loja = this.filter_venda_forma_pagamento.loja;
          }

          if (this.filter_venda_forma_pagamento.range_dates.length > 0) {
            dados_forma.dthr_ped_ini =
              this.filter_venda_forma_pagamento.range_dates[0] + " 00:00";
            dados_forma.dthr_ped_fim =
              this.filter_venda_forma_pagamento.range_dates[1] + " 23:59";
          }
          if (
            !this.filter_venda_forma_pagamento.range_dates.length == 0 &&
            this.filter_venda_forma_pagamento.range_dates.length < 2
          ) {
            this.loading_venda_forma_pagamento = false;
            this.$config.alert(
              "Preencha adequadamente os campos!",
              this.$config.dados.errorColor
            );
            this.filter_venda_forma_pagamento.error.range_dates =
              "Preencha adequadamente os campos!";
            return;
          }

          if (
            this.filter_venda_forma_pagamento.loja != 0 ||
            this.filter_venda_forma_pagamento.loja == null
          ) {
            if (
              (this.filter_venda_forma_pagamento.loja == "" &&
                this.getEnviroment()) ||
              (this.getEnviroment() &&
                this.filter_venda_forma_pagamento.loja == null)
            ) {
              this.loading_button = false;
              this.loading_venda_tipo_produto = false;
              this.$config.alert(
                "Selecione uma loja!",
                this.$config.dados.errorColor
              );
              this.filter_venda_forma_pagamento.error.loja =
                "Selecione uma loja!";
              return;
            }
          }

          this.getVendasPorFormaDePagamento(dados_forma);
          break;
        case "venda_por_produto":
          if (
            this.filter_venda_produto.loja !== "" &&
            this.filter_venda_produto.loja !== null
          ) {
            dados_produto.loja = this.filter_venda_produto.loja;
          }

          if (
            this.filter_venda_produto.produto !== "" &&
            this.filter_venda_produto.produto !== null
          ) {
            dados_produto.dsc_produto = this.filter_venda_produto.produto;
          }

          if (this.filter_venda_produto.range_dates.length > 0) {
            dados_produto.dthr_ped_ini =
              this.filter_venda_produto.range_dates[0] + " 00:00";
            dados_produto.dthr_ped_fim =
              this.filter_venda_produto.range_dates[1] + " 23:59";
          }

          if (
            this.filter_venda_produto.loja != 0 ||
            this.filter_venda_produto.loja == null
          ) {
            if (
              (this.filter_venda_produto.loja == "" && this.getEnviroment()) ||
              this.filter_venda_produto.loja == null
            ) {
              this.loading_venda_tipo_produto = false;
              this.$config.alert(
                "Selecione uma loja!",
                this.$config.dados.errorColor
              );
              this.filter_venda_produto.error.loja = "Selecione uma loja!";
              return;
            }
          }

          if (
            !this.filter_venda_produto.range_dates.length == 0 &&
            this.filter_venda_produto.range_dates.length < 2
          ) {
            this.loading_venda_por_produto = false;
            this.$config.alert(
              "Preencha adequadamente os campos!",
              this.$config.dados.errorColor
            );
            this.filter_venda_produto.error.range_dates =
              "Preencha adequadamente os campos!";
            return;
          }
          this.getVendasPorProduto(dados_produto);
          break;
        case "venda_tipo_produto":
          if (
            this.filter_venda_tipo_produto.tipo_produto !== "" &&
            this.filter_venda_tipo_produto.tipo_produto !== null
          ) {
            dados_tipo.tipo_produto =
              this.filter_venda_tipo_produto.tipo_produto;
          }

          if (
            this.filter_venda_tipo_produto.tipo_variacao !== "" &&
            this.filter_venda_tipo_produto.tipo_variacao !== null
          ) {
            dados_tipo.tipo_variacao =
              this.filter_venda_tipo_produto.tipo_variacao;
          }

          if (
            this.filter_venda_tipo_produto.loja !== "" &&
            this.filter_venda_tipo_produto.loja !== null
          ) {
            dados_tipo.loja = this.filter_venda_tipo_produto.loja;
          }

          if (this.filter_venda_tipo_produto.range_dates.length > 0) {
            dados_tipo.dthr_ped_ini =
              this.filter_venda_tipo_produto.range_dates[0] + " 00:00";
            dados_tipo.dthr_ped_fim =
              this.filter_venda_tipo_produto.range_dates[1] + " 23:59";
          }
          if (
            !this.filter_venda_tipo_produto.range_dates.length == 0 &&
            this.filter_venda_tipo_produto.range_dates.length < 2
          ) {
            this.loading_venda_tipo_produto = false;
            this.$config.alert(
              "Preencha adequadamente os campos!",
              this.$config.dados.errorColor
            );
            this.filter_venda_tipo_produto.error.range_dates =
              "Preencha adequadamente os campos!";
            return;
          }

          if (
            this.filter_venda_tipo_produto.loja != 0 ||
            this.filter_venda_tipo_produto.loja == null
          ) {
            if (
              (this.filter_venda_tipo_produto.loja == "" &&
                this.getEnviroment()) ||
              this.filter_venda_tipo_produto.loja == null
            ) {
              this.loading_button = false;
              this.loading_venda_tipo_produto = false;
              this.$config.alert(
                "Selecione uma loja!",
                this.$config.dados.errorColor
              );
              this.filter_venda_tipo_produto.error.loja = "Selecione uma loja!";
              return;
            }
          }

          this.getVendasPorTipoDeProduto(dados_tipo);
          break;
        case "venda_pdv":
          if (this.getEnviroment()) {
            dados_venda_pdv.loja = this.filter_venda_por_pdv.loja;
          } else {
            dados_venda_pdv.loja =
              this.$axios.getLocal("oe_user_info").data.loja;
          }
          dados_venda_pdv.idponto_venda =
            this.filter_venda_por_pdv.ponto_de_venda;
          if (this.filter_venda_por_pdv.range_dates.length > 0) {
            dados_venda_pdv.dthr_ped_ini =
              this.filter_venda_por_pdv.range_dates[0] + " 00:00";
            dados_venda_pdv.dthr_ped_fim =
              this.filter_venda_por_pdv.range_dates[1] + " 23:59";
          }
          dados_venda_pdv.idequipamento = this.filter_venda_por_pdv.equipamento;
          dados_venda_pdv.forma_pagamento = this.filter_venda_por_pdv.forma_pag;
          if (
            this.filter_venda_por_pdv.loja != 0 ||
            this.filter_venda_por_pdv.loja == null
          ) {
            if (
              (this.getEnviroment() && this.filter_venda_por_pdv.loja == "") ||
              (this.getEnviroment() && this.filter_venda_por_pdv.loja == null)
            ) {
              this.loading_button = false;
              this.loading_venda_tipo_produto = false;
              this.$config.alert(
                "Selecione uma loja!",
                this.$config.dados.errorColor
              );
              this.filter_venda_por_pdv.error.loja = "Selecione uma loja!";
              return;
            }
          }
          this.getVendasPorPdv(dados_venda_pdv);
          break;
        case "cupom":
          if (this.filter_cupom_desconto.loja === "" && this.getEnviroment()) {
            this.$config.alert(
              "Selecione uma loja!",
              this.$config.dados.errorColor
            );
            this.filter_cupom_desconto.error.loja = "Selecione uma loja!";
            return;
          }

          if (
            !this.filter_cupom_desconto.range_dates.length == 0 &&
            this.filter_cupom_desconto.range_dates.length < 2
          ) {
            this.$config.alert(
              "Preencha adequadamente os campos!",
              this.$config.dados.errorColor
            );
            this.filter_cupom_desconto.error.range_dates =
              "Preencha adequadamente os campos!";
            return;
          }

          dados_cupom.dthr_cupom_aplicado_ini =
            this.filter_cupom_desconto.range_dates.length > 0
              ? this.filter_cupom_desconto.range_dates[0] + " 00:00"
              : "";
          dados_cupom.dthr_cupom_aplicado_fim =
            this.filter_cupom_desconto.range_dates.length > 0
              ? this.filter_cupom_desconto.range_dates[1] + " 23:59"
              : "";

          dados_cupom.codigo = this.filter_cupom_desconto.codigo;
          dados_cupom.dsc_produto = this.filter_cupom_desconto.produto;

          dados_cupom.codigo = this.filter_cupom_desconto.codigo;
          dados_cupom.idconsumidor = this.filter_cupom_desconto.consumidor;

          if (
            this.$axios.getLocal("oe_user_info")?.data?.user_type === "loja"
          ) {
            dados_cupom.loja = Number(
              this.$axios.getLocal("oe_user_info")?.data?.loja
            );
          } else dados_cupom.loja = this.filter_cupom_desconto.loja;

          this.getCuponsRelatorio(dados_cupom);
          break;
        case "consumidor_final":
          if (this.filter_consumidor_final.range_dates.length > 0) {
            dados_consumidor.dthr_liberacao_ini =
              this.filter_consumidor_final.range_dates[0] + " 00:00";
            dados_consumidor.dthr_liberacao_fim =
              this.filter_consumidor_final.range_dates[1] + " 23:59";
          }
          if (
            this.filter_consumidor_final.loja != 0 ||
            this.filter_consumidor_final.loja == null
          ) {
            if (
              (this.getEnviroment() &&
                this.filter_consumidor_final.loja == "") ||
              (this.getEnviroment() &&
                this.filter_consumidor_final.loja == null)
            ) {
              this.loading_button_consumidor = false;
              this.loading_consumidor_final = false;
              this.$config.alert(
                "Selecione uma loja!",
                this.$config.dados.errorColor
              );
              this.filter_consumidor_final.error.loja = "Selecione uma loja!";
              return;
            }
          }
          if (
            this.filter_consumidor_final.loja !== "" &&
            this.filter_consumidor_final.loja !== null
          ) {
            dados_consumidor.loja = this.filter_consumidor_final.loja;
          }
          if (
            !this.filter_consumidor_final.range_dates.length == 0 &&
            this.filter_consumidor_final.range_dates.length < 2
          ) {
            this.loading_consumidor_final = false;
            this.$config.alert(
              "Preencha adequadamente os campos!",
              this.$config.dados.errorColor
            );
            this.filter_consumidor_final.error.range_dates =
              "Preencha adequadamente os campos!";
            return;
          }
          this.getConsumidorFinal(dados_consumidor);
          break;

        // case "cancelamentos_taxas":
        //   if (this.filter_cancelamentos_taxas.range_dates.length > 0) {
        //     dados_cancelamentos.dthr_ped_ini =
        //       this.filter_cancelamentos_taxas.range_dates[0] + " 00:00";
        //     dados_cancelamentos.dthr_ped_fim =
        //       this.filter_cancelamentos_taxas.range_dates[1] + " 23:59";
        //   }

        //   if (
        //     this.filter_cancelamentos_taxas.canal_vendas !== "" &&
        //     this.filter_cancelamentos_taxas.canal_vendas !== null
        //   ) {
        //     dados_cancelamentos.canal_venda =
        //       this.filter_cancelamentos_taxas.canal_vendas;
        //   }

        //   if (
        //     this.filter_cancelamentos_taxas.loja !== "" &&
        //     this.filter_cancelamentos_taxas.loja !== null
        //   ) {
        //     dados_cancelamentos.loja = this.filter_cancelamentos_taxas.loja;
        //   }

        //   if (
        //     this.filter_cancelamentos_taxas.loja != 0 ||
        //     this.filter_cancelamentos_taxas.loja == 0 ||
        //     this.filter_cancelamentos_taxas.loja == null
        //   ) {
        //     if (
        //       (this.filter_cancelamentos_taxas.loja == "" &&
        //         this.getEnviroment()) ||
        //       (this.getEnviroment() &&
        //         this.filter_cancelamentos_taxas.loja == null)
        //     ) {
        //       this.loading_venda_tipo_produto = false;
        //       this.$config.alert(
        //         "Selecione uma loja!",
        //         this.$config.dados.errorColor
        //       );
        //       this.filter_cancelamentos_taxas.error.loja =
        //         "Selecione uma loja!";
        //       return;
        //     }
        //   }

        //   if (
        //     !this.filter_cancelamentos_taxas.range_dates.length == 0 &&
        //     this.filter_cancelamentos_taxas.range_dates.length < 2
        //   ) {
        //     this.loading_venda_por_canal = false;
        //     this.$config.alert(
        //       "Preencha adequadamente os campos!",
        //       this.$config.dados.errorColor
        //     );
        //     this.filter_cancelamentos_taxas.error.range_dates =
        //       "Preencha adequadamente os campos!";
        //     return;
        //   }
        //   this.getCancelamentosTaxas(dados_cancelamentos);
        //   break;

        default:
          break;
      }
    },
    getCuponsRelatorio(payload) {
      this.loading_button_cupom = true;
      this.loading_cupom_desconto = true;
      this.$axios.post(this.ENDPOINTS.RELATORIO_CUPOM, payload).then(res => {
        this.cupons_descontos = res;
        this.loading_button_cupom = false;
        this.loading_cupom_desconto = false;
      });
    },
    imprimirPDF(relatorio) {
      this.loading_button_export_pdf = true;
      let dados = {
        exportation: "PDF",
      };
      switch (relatorio) {
        case "venda_por_dia":
          if (this.filter_venda_por_dia.range_dates.length > 0) {
            dados.dthr_ped_ini =
              this.filter_venda_por_dia.range_dates[0] + " 00:00";
            dados.dthr_ped_fim =
              this.filter_venda_por_dia.range_dates[1] + " 23:59";
          }
          if (
            this.filter_venda_por_dia.loja !== "" &&
            this.filter_venda_por_dia.loja !== null
          ) {
            dados.loja = this.filter_venda_por_dia.loja;
          }
          this.$axios
            .postPDF(this.ENDPOINTS.LISTAR_VENDA_POR_DIA, JSON.stringify(dados))
            .then(response => {
              if (response) {
                var file = new Blob([response], { type: "application/pdf" });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                this.loading_button_export_pdf = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "consumidor_final":
          if (this.filter_consumidor_final.range_dates.length > 0) {
            dados.dthr_liberacao_ini =
              this.filter_consumidor_final.range_dates[0] + " 00:00";
            dados.dthr_liberacao_fim =
              this.filter_consumidor_final.range_dates[1] + " 23:59";
          }
          if (
            this.filter_consumidor_final.loja !== "" &&
            this.filter_consumidor_final.loja !== null
          ) {
            dados.loja = this.filter_consumidor_final.loja;
          }
          this.$axios
            .postPDF(
              this.ENDPOINTS.LISTAR_NF_CONSUMIDOR_FINAL,
              JSON.stringify(dados)
            )
            .then(response => {
              if (response) {
                var file = new Blob([response], { type: "application/pdf" });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                this.loading_button_export_pdf = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "venda_forma_pagamento":
          {
            dados.forma_pagamento =
              this.filter_venda_forma_pagamento.forma_de_pagamento;
          }

          if (this.filter_venda_forma_pagamento.range_dates.length > 0) {
            dados.dthr_ped_ini =
              this.filter_venda_forma_pagamento.range_dates[0] + " 00:00";
            dados.dthr_ped_fim =
              this.filter_venda_forma_pagamento.range_dates[1] + " 23:59";
          }
          if (
            this.filter_venda_forma_pagamento.loja !== "" &&
            this.filter_venda_forma_pagamento.loja !== null
          ) {
            dados.loja = this.filter_venda_forma_pagamento.loja;
          }
          this.$axios
            .postPDF(
              this.ENDPOINTS.LISTAR_VENDA_POR_FORMA_PGT,
              JSON.stringify(dados)
            )
            .then(response => {
              if (response) {
                var file = new Blob([response], { type: "application/pdf" });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                this.loading_button_export_pdf = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "venda_por_pdv":
          if (this.getEnviroment()) {
            dados.loja = this.filter_venda_por_pdv.loja;
          } else {
            dados.loja = this.$axios.getLocal("oe_user_info").data.loja;
          }
          dados.idponto_venda = this.filter_venda_por_pdv.ponto_de_venda;
          if (this.filter_venda_por_pdv.range_dates.length > 0) {
            dados.dthr_ped_ini =
              this.filter_venda_por_pdv.range_dates[0] + " 00:00";
            dados.dthr_ped_fim =
              this.filter_venda_por_pdv.range_dates[1] + " 23:59";
          }
          dados.idequipamento = this.filter_venda_por_pdv.equipamento;
          dados.forma_pagamento = this.filter_venda_por_pdv.forma_pag;
          this.$axios
            .postPDF(this.ENDPOINTS.LISTAR_VENDA_POR_PDV, dados)
            .then(response => {
              var file = new Blob([response], { type: "application/pdf" });
              var fileURL = URL.createObjectURL(file);
              window.open(fileURL);
              this.loading_button_export_pdf = false;
            });
          break;
        case "venda_tipo_produto":
          {
            dados.tipo_produto = this.filter_venda_tipo_produto.tipo_produto;
          }

          if (this.filter_venda_tipo_produto.range_dates.length > 0) {
            dados.dthr_ped_ini =
              this.filter_venda_tipo_produto.range_dates[0] + " 00:00";
            dados.dthr_ped_fim =
              this.filter_venda_tipo_produto.range_dates[1] + " 23:59";
          }
          if (
            this.filter_venda_tipo_produto.loja !== "" &&
            this.filter_venda_tipo_produto.loja !== null
          ) {
            dados.loja = this.filter_venda_tipo_produto.loja;
          }
          this.$axios
            .postPDF(
              this.ENDPOINTS.LISTAR_VENDA_POR_TIPO_PRODUTO,
              JSON.stringify(dados)
            )
            .then(response => {
              if (response) {
                var file = new Blob([response], { type: "application/pdf" });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                this.loading_button_export_pdf = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "venda_por_produto":
          if (
            this.filter_venda_produto.loja !== "" &&
            this.filter_venda_produto.loja !== null
          ) {
            dados.loja = this.filter_venda_produto.loja;
          }

          if (
            this.filter_venda_produto.produto !== "" &&
            this.filter_venda_produto.produto !== null
          ) {
            dados.dsc_produto = this.filter_venda_produto.produto;
          }

          if (this.filter_venda_produto.range_dates.length > 0) {
            dados.dthr_ped_ini =
              this.filter_venda_produto.range_dates[0] + " 00:00";
            dados.dthr_ped_fim =
              this.filter_venda_produto.range_dates[1] + " 23:59";
          }
          this.$axios
            .postPDF(
              this.ENDPOINTS.LISTAR_VENDA_POR_PRODUTO,
              JSON.stringify(dados)
            )
            .then(response => {
              if (response) {
                var file = new Blob([response], { type: "application/pdf" });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                this.loading_button_export_pdf = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "venda_por_canal":
          if (this.filter_venda_por_canal.range_dates.length > 0) {
            dados.dthr_ped_ini =
              this.filter_venda_por_canal.range_dates[0] + " 00:00";
            dados.dthr_ped_fim =
              this.filter_venda_por_canal.range_dates[1] + " 23:59";
          }

          if (
            this.filter_venda_por_canal.canal_vendas !== "" &&
            this.filter_venda_por_canal.canal_vendas !== null
          ) {
            dados.canal_venda = this.filter_venda_por_canal.canal_vendas;
          }

          if (
            this.filter_venda_por_canal.loja !== "" &&
            this.filter_venda_por_canal.loja !== null
          ) {
            dados.loja = this.filter_venda_por_canal.loja;
          }
          this.$axios
            .postPDF(
              this.ENDPOINTS.LISTAR_VENDA_POR_CANAL,
              JSON.stringify(dados)
            )
            .then(response => {
              if (response) {
                var file = new Blob([response], { type: "application/pdf" });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                this.loading_button_export_pdf = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "recebimentos":
          if (this.filter_recebimentos.initDateView) {
            dados.dthr_ini = `${this.filter_recebimentos.initDate} 00:00`;
          }
          if (this.filter_recebimentos.endDateView) {
            dados.dthr_fim = `${this.filter_recebimentos.endDate} 00:00`;
          }

          if (!this.getEnviroment()) {
            dados.tipo_pessoa = "PONTO_VENDA";
            dados.idponto_venda = this.filter_recebimentos.pessoa;
          } else {
            switch (this.filter_recebimentos.tipo_pessoa) {
              case "idponto_venda":
                dados.tipo_pessoa = "PONTO_VENDA";
                dados.idponto_venda = this.filter_recebimentos.pessoa;
                break;
              case "idloja":
                dados.tipo_pessoa = "LOJA";
                dados.loja = store.getters.storeSequencial;
                break;
              default:
                dados.tipo_pessoa = "LOJA";
                dados.loja = store.getters.storeSequencial;
            }
          }
          this.$axios
            .postPDF(
              this.ENDPOINTS.LISTAR_RECEBIMENTOS + "/exportar",
              JSON.stringify(dados)
            )
            .then(response => {
              if (response) {
                var file = new Blob([response], { type: "application/pdf" });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                this.loading_button_export_pdf = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "cupom_desconto":
          if (this.filter_cupom_desconto.range_dates.length > 0) {
            dados.dthr_cupom_aplicado_ini =
              this.filter_cupom_desconto.range_dates[0] + " 00:00";
            dados.dthr_cupom_aplicado_fim =
              this.filter_cupom_desconto.range_dates[1] + " 23:59";
          }
          if (this.$axios.getLocal("oe_user_info").data.user_type === "loja") {
            dados.loja = this.$axios.getLocal("oe_user_info")?.data?.loja;
          } else if (
            this.filter_cupom_desconto.loja !== "" &&
            this.filter_cupom_desconto.loja !== null
          ) {
            dados.loja = this.filter_cupom_desconto.loja;
          }
          if (
            this.filter_cupom_desconto.codigo !== "" &&
            this.filter_cupom_desconto.codigo !== null
          ) {
            dados.codigo = this.filter_cupom_desconto.codigo;
          }
          if (
            this.filter_cupom_desconto.produto !== "" &&
            this.filter_cupom_desconto.produto !== null
          ) {
            dados.dsc_produto = this.filter_cupom_desconto.produto;
          }
          if (
            this.filter_cupom_desconto.consumidor !== "" &&
            this.filter_cupom_desconto.consumidor !== null
          ) {
            dados.idconsumidor = this.filter_cupom_desconto.consumidor;
          }
          this.$axios
            .postPDF(this.ENDPOINTS.RELATORIO_CUPOM, dados)
            .then(res => {
              if (res) {
                var file = new Blob([res], { type: "application/pdf" });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                this.loading_button_export_pdf = false;
              }

              this.loading_button_export_pdf = false;
            })
            .catch(error => {
              this.loading_button_export_pdf = false;
              throw new Error(error);
            });
          break;

        // case "cancelamentos_taxas":
        //   if (this.filter_cancelamentos_taxas.range_dates.length > 0) {
        //     dados.dthr_ped_ini =
        //       this.filter_cancelamentos_taxas.range_dates[0] + " 00:00";
        //     dados.dthr_ped_fim =
        //       this.filter_cancelamentos_taxas.range_dates[1] + " 23:59";
        //   }

        //   if (
        //     this.filter_cancelamentos_taxas.canal_vendas !== "" &&
        //     this.filter_cancelamentos_taxas.canal_vendas !== null
        //   ) {
        //     dados.canal_venda = this.filter_venda_por_canal.canal_vendas;
        //   }

        //   if (
        //     this.filter_cancelamentos_taxas.loja !== "" &&
        //     this.filter_cancelamentos_taxas.loja !== null
        //   ) {
        //     dados.loja = this.filter_cancelamentos_taxas.loja;
        //   }
        //   this.$axios
        //     .postPDF(
        //       this.ENDPOINTS.LISTAR_CANCELAMENTOS_TAXAS,
        //       JSON.stringify(dados)
        //     )
        //     .then(response => {
        //       if (response) {
        //         var file = new Blob([response], { type: "application/pdf" });
        //         var fileURL = URL.createObjectURL(file);
        //         window.open(fileURL);
        //         this.loading_button_export_pdf = false;
        //       }
        //     })
        //     .catch(error => {
        //       throw new Error(error);
        //     });
        //   break;
      }
    },

    imprimirCSV(relatorio) {
      this.loading_button_export_csv = true;
      let dados = { exportation: "CSV" };
      switch (relatorio) {
        case "venda_por_dia":
          if (this.filter_venda_por_dia.range_dates.length > 0) {
            dados.dthr_ped_ini =
              this.filter_venda_por_dia.range_dates[0] + " 00:00";
            dados.dthr_ped_fim =
              this.filter_venda_por_dia.range_dates[1] + " 23:59";
          }
          if (
            this.filter_venda_por_dia.loja !== "" &&
            this.filter_venda_por_dia.loja !== null
          ) {
            dados.loja = this.filter_venda_por_dia.loja;
          }

          this.$axios
            .postPDF(this.ENDPOINTS.LISTAR_VENDA_POR_DIA, JSON.stringify(dados))
            .then(response => {
              if (response) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                var file = new Blob([response], { type: "text/csv" });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "Relatório Vendas por Dia";
                a.click();
                window.URL.revokeObjectURL(fileURL);
                this.loading_button_export_csv = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "consumidor_final":
          if (this.filter_consumidor_final.range_dates.length > 0) {
            dados.dthr_liberacao_ini =
              this.filter_consumidor_final.range_dates[0] + " 00:00";
            dados.dthr_liberacao_fim =
              this.filter_consumidor_final.range_dates[1] + " 23:59";
          }
          if (
            this.filter_consumidor_final.loja !== "" &&
            this.filter_consumidor_final.loja !== null
          ) {
            dados.loja = this.filter_consumidor_final.loja;
          }
          this.$axios
            .postPDF(
              this.ENDPOINTS.LISTAR_NF_CONSUMIDOR_FINAL,
              JSON.stringify(dados)
            )
            .then(response => {
              if (response) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                var file = new Blob([response], { type: "text/csv" });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "Relatório NF Consumidor Final";
                a.click();
                window.URL.revokeObjectURL(fileURL);
                this.loading_button_export_csv = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "venda_forma_pagamento":
          {
            dados.forma_pagamento =
              this.filter_venda_forma_pagamento.forma_de_pagamento;
          }

          if (this.filter_venda_forma_pagamento.range_dates.length > 0) {
            dados.dthr_ped_ini =
              this.filter_venda_forma_pagamento.range_dates[0] + " 00:00";
            dados.dthr_ped_fim =
              this.filter_venda_forma_pagamento.range_dates[1] + " 23:59";
          }
          if (
            this.filter_venda_forma_pagamento.loja !== "" &&
            this.filter_venda_forma_pagamento.loja !== null
          ) {
            dados.loja = this.filter_venda_forma_pagamento.loja;
          }
          this.$axios
            .postPDF(
              this.ENDPOINTS.LISTAR_VENDA_POR_FORMA_PGT,
              JSON.stringify(dados)
            )
            .then(response => {
              if (response) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                var file = new Blob([response], { type: "text/csv" });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "Relatório Vendas por Forma de PGT";
                a.click();
                window.URL.revokeObjectURL(fileURL);
                this.loading_button_export_csv = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "venda_por_pdv":
          if (this.getEnviroment()) {
            dados.loja = this.filter_venda_por_pdv.loja;
          } else {
            dados.loja = this.$axios.getLocal("oe_user_info").data.loja;
          }
          dados.idponto_venda = this.filter_venda_por_pdv.ponto_de_venda;
          if (this.filter_venda_por_pdv.range_dates.length > 0) {
            dados.dthr_ped_ini =
              this.filter_venda_por_pdv.range_dates[0] + " 00:00";
            dados.dthr_ped_fim =
              this.filter_venda_por_pdv.range_dates[1] + " 23:59";
          }
          dados.idequipamento = this.filter_venda_por_pdv.equipamento;
          dados.forma_pagamento = this.filter_venda_por_pdv.forma_pag;
          this.$axios
            .postPDF(this.ENDPOINTS.LISTAR_VENDA_POR_PDV, dados)
            .then(response => {
              var a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              var file = new Blob([response], { type: "text/csv" });
              var fileURL = URL.createObjectURL(file);
              a.href = fileURL;
              a.download = "Relatório Venda por Ponto de venda.";
              a.click();
              window.URL.revokeObjectURL(fileURL);
              this.loading_button_export_csv = false;
            });
          break;
        case "venda_tipo_produto":
          dados.tipo_produto = this.filter_venda_tipo_produto.tipo_produto;
          dados.tipo_variacao = this.filter_venda_tipo_produto.tipo_variacao;

          if (this.filter_venda_tipo_produto.range_dates.length > 0) {
            dados.dthr_ped_ini =
              this.filter_venda_tipo_produto.range_dates[0] + " 00:00";
            dados.dthr_ped_fim =
              this.filter_venda_tipo_produto.range_dates[1] + " 23:59";
          }
          if (
            this.filter_venda_tipo_produto.loja !== "" &&
            this.filter_venda_tipo_produto.loja !== null
          ) {
            dados.loja = this.filter_venda_tipo_produto.loja;
          }
          this.$axios
            .postPDF(
              this.ENDPOINTS.LISTAR_VENDA_POR_TIPO_PRODUTO,
              JSON.stringify(dados)
            )
            .then(response => {
              if (response) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                var file = new Blob([response], { type: "text/csv" });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "Relatório Venda por Tipo de Prod.";
                a.click();
                window.URL.revokeObjectURL(fileURL);
                this.loading_button_export_csv = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "venda_por_produto":
          if (
            this.filter_venda_produto.loja !== "" &&
            this.filter_venda_produto.loja !== null
          ) {
            dados.loja = this.filter_venda_produto.loja;
          }

          if (
            this.filter_venda_produto.produto !== "" &&
            this.filter_venda_produto.produto !== null
          ) {
            dados.dsc_produto = this.filter_venda_produto.produto;
          }

          if (this.filter_venda_produto.range_dates.length > 0) {
            dados.dthr_ped_ini =
              this.filter_venda_produto.range_dates[0] + " 00:00";
            dados.dthr_ped_fim =
              this.filter_venda_produto.range_dates[1] + " 23:59";
          }
          this.$axios
            .postPDF(
              this.ENDPOINTS.LISTAR_VENDA_POR_PRODUTO,
              JSON.stringify(dados)
            )
            .then(response => {
              if (response) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                var file = new Blob([response], { type: "text/csv" });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "Relatório Venda por Produto";
                a.click();
                window.URL.revokeObjectURL(fileURL);
                this.loading_button_export_csv = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "venda_por_canal":
          if (this.filter_venda_por_canal.range_dates.length > 0) {
            dados.dthr_ped_ini =
              this.filter_venda_por_canal.range_dates[0] + " 00:00";
            dados.dthr_ped_fim =
              this.filter_venda_por_canal.range_dates[1] + " 23:59";
          }

          if (
            this.filter_venda_por_canal.canal_vendas !== "" &&
            this.filter_venda_por_canal.canal_vendas !== null
          ) {
            dados.canal_venda = this.filter_venda_por_canal.canal_vendas;
          }
          if (
            this.filter_venda_por_canal.loja !== "" &&
            this.filter_venda_por_canal.loja !== null
          ) {
            dados.loja = this.filter_venda_por_canal.loja;
          }
          this.$axios
            .postPDF(
              this.ENDPOINTS.LISTAR_VENDA_POR_CANAL,
              JSON.stringify(dados)
            )
            .then(response => {
              if (response) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                var file = new Blob([response], { type: "text/csv" });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "Relatório Venda por Canal";
                a.click();
                window.URL.revokeObjectURL(fileURL);
                this.loading_button_export_csv = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "recebimentos":
          if (this.filter_recebimentos.initDateView) {
            dados.dthr_ini = `${this.filter_recebimentos.initDate} 00:00`;
          }
          if (this.filter_recebimentos.endDateView) {
            dados.dthr_fim = `${this.filter_recebimentos.endDate} 00:00`;
          }

          if (!this.getEnviroment()) {
            dados.tipo_pessoa = "PONTO_VENDA";
            dados.idponto_venda = this.filter_recebimentos.pessoa;
          } else {
            switch (this.filter_recebimentos.tipo_pessoa) {
              case "idponto_venda":
                dados.tipo_pessoa = "PONTO_VENDA";
                dados.idponto_venda = this.filter_recebimentos.pessoa;
                break;
              case "idagente":
                dados.tipo_pessoa = "AGENTE";
                dados.idagente = this.filter_recebimentos.pessoa;
                break;
              case "idloja":
                dados.tipo_pessoa = "LOJA";
                dados.loja = store.getters.storeSequencial;
                break;
              default:
                dados.tipo_pessoa = "LOJA";
                dados.loja = store.getters.storeSequencial;
            }
          }
          this.$axios
            .postPDF(
              this.ENDPOINTS.LISTAR_RECEBIMENTOS + "/exportar",
              JSON.stringify(dados)
            )
            .then(response => {
              if (response) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                var file = new Blob([response], { type: "text/csv" });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "Relatório Recebimentos";
                a.click();
                window.URL.revokeObjectURL(fileURL);
                this.loading_button_export_csv = false;
              }
            })
            .catch(error => {
              throw new Error(error);
            });
          break;
        case "cupom_desconto":
          if (this.filter_cupom_desconto.range_dates.length > 0) {
            dados.dthr_cupom_aplicado_ini =
              this.filter_cupom_desconto.range_dates[0] + " 00:00";
            dados.dthr_cupom_aplicado_fim =
              this.filter_cupom_desconto.range_dates[1] + " 23:59";
          }
          if (this.$axios.getLocal("oe_user_info").data.user_type === "loja") {
            dados.loja = this.$axios.getLocal("oe_user_info")?.data?.loja;
          } else if (
            this.filter_cupom_desconto.loja !== "" &&
            this.filter_cupom_desconto.loja !== null
          ) {
            dados.loja = this.filter_cupom_desconto.loja;
          }
          if (
            this.filter_cupom_desconto.codigo !== "" &&
            this.filter_cupom_desconto.codigo !== null
          ) {
            dados.codigo = this.filter_cupom_desconto.codigo;
          }
          if (
            this.filter_cupom_desconto.produto !== "" &&
            this.filter_cupom_desconto.produto !== null
          ) {
            dados.dsc_produto = this.filter_cupom_desconto.produto;
          }
          if (
            this.filter_cupom_desconto.consumidor !== "" &&
            this.filter_cupom_desconto.consumidor !== null
          ) {
            dados.idconsumidor = this.filter_cupom_desconto.consumidor;
          }

          this.$axios
            .postPDF(this.ENDPOINTS.RELATORIO_CUPOM, dados)
            .then(res => {
              if (res) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                var file = new Blob([res], { type: "text/csv" });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "Relatório Cupom de Desconto";
                a.click();
                window.URL.revokeObjectURL(fileURL);
                this.loading_button_export_csv = false;
              }
              this.loading_button_export_csv = false;
            })
            .catch(error => {
              this.loading_button_export_csv = false;
              throw new Error(error);
            });
          break;
        // case "cancelamentos_taxas":
        //   if (this.filter_cancelamentos_taxas.range_dates.length > 0) {
        //     dados.dthr_ped_ini =
        //       this.filter_cancelamentos_taxas.range_dates[0] + " 00:00";
        //     dados.dthr_ped_fim =
        //       this.filter_cancelamentos_taxas.range_dates[1] + " 23:59";
        //   }

        //   if (
        //     this.filter_cancelamentos_taxas.canal_vendas !== "" &&
        //     this.filter_cancelamentos_taxas.canal_vendas !== null
        //   ) {
        //     dados.canal_venda = this.filter_cancelamentos_taxas.canal_vendas;
        //   }
        //   if (
        //     this.filter_cancelamentos_taxas.loja !== "" &&
        //     this.filter_cancelamentos_taxas.loja !== null
        //   ) {
        //     dados.loja = this.filter_cancelamentos_taxas.loja;
        //   }
        //   this.$axios
        //     .postPDF(
        //       this.ENDPOINTS.LISTAR_CANCELAMENTOS_TAXAS,
        //       JSON.stringify(dados)
        //     )
        //     .then(response => {
        //       if (response) {
        //         var a = document.createElement("a");
        //         document.body.appendChild(a);
        //         a.style = "display: none";
        //         var file = new Blob([response], { type: "text/csv" });
        //         var fileURL = URL.createObjectURL(file);
        //         a.href = fileURL;
        //         a.download = "Relatório de Receitas de Cancelamentos com Taxas";
        //         a.click();
        //         window.URL.revokeObjectURL(fileURL);
        //         this.loading_button_export_csv = false;
        //       }
        //     })
        //     .catch(error => {
        //       throw new Error(error);
        //     });
        //   break;
      }
    },

    relatorioPDF() {
      this.loading_button_export_pdf = true;
      let dados = { export_pdf: "PDF" };
      if (this.filter_consumidor_final.range_dates.length > 0) {
        dados.dthr_liberacao_ini =
          this.filter_consumidor_final.range_dates[0] + " 00:00";
        dados.dthr_liberacao_fim =
          this.filter_consumidor_final.range_dates[1] + " 23:59";
      }
      if (
        this.filter_consumidor_final.loja !== "" &&
        this.filter_consumidor_final.loja !== null
      ) {
        dados.loja = this.filter_consumidor_final.loja;
      }
      this.$axios
        .postPDF(
          this.ENDPOINTS.LISTAR_NF_CONSUMIDOR_FINAL,
          JSON.stringify(dados)
        )
        .then(response => {
          if (response) {
            var file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            this.loading_button_export_pdf = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    relatorioCSV() {
      this.loading_button_export_csv = true;
      let dados = { export_csv: "CSV" };
      if (this.filter_consumidor_final.range_dates.length > 0) {
        dados.dthr_liberacao_ini =
          this.filter_consumidor_final.range_dates[0] + " 00:00";
        dados.dthr_liberacao_fim =
          this.filter_consumidor_final.range_dates[1] + " 23:59";
      }
      if (
        this.filter_consumidor_final.loja !== "" &&
        this.filter_consumidor_final.loja !== null
      ) {
        dados.loja = this.filter_consumidor_final.loja;
      }
      this.$axios
        .postPDF(
          this.ENDPOINTS.LISTAR_NF_CONSUMIDOR_FINAL,
          JSON.stringify(dados)
        )
        .then(response => {
          if (response) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            var file = new Blob([response], { type: "text/csv" });
            var fileURL = URL.createObjectURL(file);
            a.href = fileURL;
            a.download = "Relatório NF Consumidor Final";
            a.click();
            window.URL.revokeObjectURL(fileURL);
            this.loading_button_export_csv = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    limpaFiltrosRecebimentos() {
      // Filtros do relatório de recebimentos
      this.filter_recebimentos.tipo_pessoa = "idloja";
      this.filter_recebimentos.pessoa = "";
      this.filter_recebimentos.initDate = "";
      this.filter_recebimentos.initDateView = "";
      this.filter_recebimentos.endDate = "";
      this.filter_recebimentos.endDateView = "";
      this.recebimentos = [];
      this.recebimentos_totais = [];
      this.resumo_recebimentos.aguardando_liberacao = 0;
      this.resumo_recebimentos.total_comissao = 0;
      this.resumo_recebimentos.saldo_disponivel = 0;
      this.filter_recebimentos.error.loja = "";
    },

    limpaFiltrosCanal() {
      // Filtros do relatório de venda por canal
      this.filter_venda_por_canal.intervalo_datas = null;
      this.filter_venda_por_canal.canal_vendas = "";
      this.filter_venda_por_canal.loja = "";
      this.filter_venda_por_canal.range_dates = [];
      this.venda_por_canal = [];
      this.venda_por_canal_totais = [];
      this.filter_venda_por_canal.error.loja = "";
    },

    limpaFiltrosPorDia() {
      // Filtros do relatório de venda por dia
      this.filter_venda_por_dia.intervalo_datas = null;
      this.filter_venda_por_dia.loja = "";
      this.filter_venda_por_dia.range_dates = [];
      this.filter_venda_por_dia.error.loja = "";
      this.venda_por_dia = [];
      this.venda_por_dia_totais = [];
    },

    limpaFiltrosConsumidor() {
      // Filtros do relatório de venda por dia
      this.filter_consumidor_final.intervalo_datas = null;
      this.filter_consumidor_final.loja = "";
      this.filter_consumidor_final.range_dates = [];
      this.filter_consumidor_final.error.loja = "";
      this.consumidor_final = [];
      this.consumidor_final_totais = [];
    },

    limpaFiltrosFormaPagamento() {
      // Filtros do relatório de forma de pagamento
      this.filter_venda_forma_pagamento.forma_de_pagamento = "";
      this.filter_venda_forma_pagamento.loja = "";
      this.filter_venda_forma_pagamento.intervalo_datas = null;
      this.filter_venda_forma_pagamento.range_dates = [];
      this.venda_forma_pagamento = [];
      this.venda_forma_pagamento_totais = [];
      this.filter_venda_forma_pagamento.error.loja = "";
    },

    limpaFiltrosPorProduto() {
      // Filtros do relatório de venda por produto
      this.filter_venda_produto.loja = "";
      this.filter_venda_produto.produto = "";
      this.filter_venda_produto.intervalo_datas = null;
      this.filter_venda_produto.range_dates = [];
      this.venda_por_produto = [];
      this.venda_por_produto_totais = [];
      this.filter_venda_produto.error.loja = "";
    },

    limpaFiltrosTipoProduto() {
      // Filtros do relatório de venda por tipo de produto
      this.filter_venda_tipo_produto.tipo_produto = "";
      this.filter_venda_tipo_produto.tipo_variacao = "";
      this.filter_venda_tipo_produto.loja = "";
      this.filter_venda_tipo_produto.intervalo_datas = null;
      this.filter_venda_tipo_produto.range_dates = [];
      (this.venda_tipo_produto = []), (this.venda_tipo_produto_totais = []);
      this.filter_venda_tipo_produto.error.loja = "";
    },
    limpaFiltrosCupons() {
      this.filter_cupom_desconto.codigo = "";
      this.filter_cupom_desconto.consumidor = "";
      this.filter_cupom_desconto.loja = "";
      this.filter_cupom_desconto.intervalo_datas = null;
      this.filter_cupom_desconto.range_dates = [];
      this.filter_cupom_desconto.error.loja = [];
      this.filter_cupom_desconto.error.range_dates = [];
      this.cupons_descontos = [];
    },
    // limpaFiltrosCancelamentos() {
    //   // Filtros do relatório de cancelamentos com taxas
    //   this.filter_cancelamentos_taxas.intervalo_datas = null;
    //   this.filter_cancelamentos_taxas.canal_vendas = "";
    //   this.filter_cancelamentos_taxas.loja = "";
    //   this.filter_cancelamentos_taxas.range_dates = [];
    //   this.cancelamentos_taxas = [];
    //   this.cancelamentos_taxas_totais = [];
    //   this.filter_cancelamentos_taxas.error.loja = "";
    // },
  },
});

export { files };
